import React, { useRef } from 'react';
import { FormControl, Select, MenuItem } from '@mui/material';

const selectStyles = {
  height: '2.5rem',
  fontSize: '0.875rem',
};

const selectMenuProps = {
  PaperProps: {
    sx: {
      '& .MuiMenuItem-root': {
        fontSize: '0.875rem',
      },
    },
  },
  MenuListProps: {
    sx: {paddingBottom: 0},
  },
};

const HEALTH_FILTER_OPTIONS = [
  { label: 'All Sessions', value: 'ALL_SESSIONS' },
  { label: 'Issues Only', value: 'ONLY_SESSIONS_WITH_ISSUES' },
];

const SELECT_BLUR_DELAY_IN_MILLISECONDS = 0;

export default function HealthFilterSelector({ healthFilter, onHealthFilterChange }) {
  const selectRef = useRef(null);

  const handleChange = (event) => {
    onHealthFilterChange(event.target.value);
    
    setTimeout(() => {
      if (selectRef.current) {
        selectRef.current.blur();
      }
      document.activeElement.blur();
    }, SELECT_BLUR_DELAY_IN_MILLISECONDS);
  };

  const handleClose = () => {
    if (selectRef.current) {
      selectRef.current.blur();
    }
    document.activeElement.blur();
  };

  return (
    <FormControl sx={{ mt: -0.5, mb: 0.2, width: 'fit-content' }}>
      <Select
        ref={selectRef}
        value={healthFilter}
        onChange={handleChange}
        onClose={handleClose}
        sx={selectStyles}
        MenuProps={selectMenuProps}
      >
        {HEALTH_FILTER_OPTIONS.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}